<template>
  <PageWrapper :style="backgroundImage">
    <NavbarMainMobile />
    <NavbarMain />
    <BaseAlertMessage />
    <HomeWrapper />
    <Footer class="FooterHome" />
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/_shared/PageWrapper.vue'
import NavbarMain from '@/components/_shared/navbar-main/NavbarMain.vue'
import NavbarMainMobile from '@/components/_shared/navbar-main-mobile/NavbarMainMobile.vue'
import HomeWrapper from '@/components/home/HomeWrapper.vue'
import Footer from '@/components/_shared/Footer.vue'

import helpers from '@/helpers'

export default {
  name: 'home',
  components: {
    PageWrapper,
    NavbarMain,
    NavbarMainMobile,
    HomeWrapper,
    Footer
  },
  computed: {
    backgroundImage () {
      return helpers.backgroundImage('../video/video.jpg')
    }
  }
}
</script>

<style>
*{
  box-sizing: border-box;
}

body{
  margin:0;
  overflow-x:hidden;
}

.fullscreen-video-wrap{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100vh;
  overflow:hidden;
}

.fullscreen-video-wrap video{
    min-height: 100%;
    min-width: 100%;
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.header-overlay{
  height:100vh;
  position: absolute;
  top:0;
  left:0;
  width:100vw;
  z-index:0;
  opacity:0.85;
}

.HomeWrapperContent{
  z-index:2;
}
.kt-footer{
  z-index:1;
}

@media(max-width:960px){
  .kt-container{
    padding-right:3rem;
    padding-left:3rem;
  }
}
</style>
